const counter = (() => {
	let count = 1;
	return () => count++;
})();

export default {
	computed: {
		uid() {
			return (this.$options.name
				? this.$options.name.toLowerCase()
				: "unnamed") + "_" + counter().toString();
		},
	},
};
